import { PropsWithChildren, useEffect } from 'react';

import {
    EventType,
    Markets,
    useAppContext,
    useChannelContext,
    useEnvContext,
    useEventBusEmit,
    useLocale,
    useRestContext,
} from 'scbk-services';
import { VirtualKeypadProvider } from 'scbk-shared-module';
import { Loading } from 'scbk-ui-web';

import { useAppInitContext } from '../providers/AppInitProvider';

/**
 * 모바일웹 앱 초기화 처리 컴포넌트
 * @param param0
 * @returns
 */
const MobileWebInitializer: React.FC<PropsWithChildren> = ({ children }) => {
    const { initialized } = useMobileWebInitializer();
    if (!initialized) {
        return <Loading loading={true} message="MobileWebInitializer Loading" />;
    }

    return <VirtualKeypadProvider>{children}</VirtualKeypadProvider>;
};

/**
 * 모바일웹 초기화 처리 hook
 * @returns
 */
const useMobileWebInitializer = () => {
    const { initialized, setInitialized } = useAppInitContext();
    const { channel } = useChannelContext();
    const { getPreDefinedLocale } = useLocale();
    const { getPreDefinedMarket } = useEnvContext();

    const { setContext: setAppContext } = useAppContext();
    const { setContext: setRestContext } = useRestContext();
    const emit = useEventBusEmit();

    const defaultLocale = getPreDefinedLocale();
    const defaultMarket = getPreDefinedMarket(import.meta.env) || Markets.KR;

    useEffect(() => {
        //이미 초기화가 되었다면 return;
        if (initialized) {
            return;
        }

        console.log('# useMobileWebInitializer 초기화 처리 시작...');

        setAppContext({
            country: defaultMarket.toUpperCase(),
            language: defaultLocale,
            channel,
            initialized: true,
        });

        //rest api context update
        setRestContext({
            country: defaultMarket.toUpperCase(),
            locale: defaultLocale,
            channel,
        });

        setInitialized(true);

        emit(EventType.ScCoreReady);

        console.log('# useMobileWebInitializer 초기화 처리 완료...');
    }, [initialized]);

    return { initialized };
};

export { MobileWebInitializer };
